// extracted by mini-css-extract-plugin
export var menuIcon = "_t8-0";
export var menuIconInline = "_t8-1";